import type { GalleryEmbedded } from '../utils';
import GalleryModalVideoDefault from './GalleryModalVideoDefault';
import GalleryModalVideoVimeo from './GalleryModalVideoVimeo';
import GalleryModalVideoYoutube from './GalleryModalVideoYoutube';

interface GalleryModalVideoProps {
  video: GalleryEmbedded;
}

const GalleryModalVideo: React.FC<GalleryModalVideoProps> = ({ video }) => {
  switch (video.embeddedType) {
    case 'VIMEO':
      return <GalleryModalVideoVimeo video={video} />;
    case 'YOUTUBE':
      return <GalleryModalVideoYoutube video={video} />;
    default:
      return <GalleryModalVideoDefault video={video} />;
  }
};

export default GalleryModalVideo;
